export const MONTH_NAME_LIST = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// fnb를 포함하는 route name 리스트
export const CONTAINED_FNB_ROUTE_NAME_LIST = [
  'PointHistory',
  'ExchangeHistory',
  'GlobalWithdrawInfo',
  'GlobalWithdrawForm',
  'GlobalWithdrawResult',
];

// Point Status 의 상태 분류
export const POINT_STATUS_CLASS = {
  1: 'plus',
  2: 'minus',
  3: 'cancel',
};

// Exchange Status 의 상태 분류
// 여기에 포함되지 않은 status code 들은 기본 클래스로 표시됨
export const EXCHANGE_STATUS_CLASS = {
  PLUS: [1, 2, 4],
  MINUS: [3, 6, 7],
};

// Global Exchange Status 의 상태 분류
// 여기에 포함되지 않은 status code 들은 기본 클래스로 표시됨
export const GLOBAL_EXCHANGE_STATUS_CLASS = {
  PLUS: [0, 1],
  MINUS: [3, 11, 31, 32],
};

// Exchange Status 에 따른 Global Withdraw Status Code (historyParameter)
// Ref Doc - https://fed-rewardpoint-docs.s3.ap-northeast-2.amazonaws.com/rpweb-api/v1/globalWithdraw/index.html#_%EA%B8%80%EB%A1%9C%EB%B2%8C_%EC%B6%9C%EA%B8%88_%EB%82%B4%EC%97%AD_%EC%A1%B0%ED%9A%8C
export const GLOBAL_WITHDRAW_REQUEST_STATUS_BY_EXCHANGE_STATUS = {
  0: 4,
  1: 0,
  2: 1,
  3: 31,
  4: 2,
  5: 11,
  6: 3,
  7: 32,
};

// Global Exchange Status Code 에 따른 다국어 객체 globalStatusRow index..
// 참고 - exchangeHistory.globalStatusRow
export const GLOBAL_EXCHANGE_STATUS_TO_SHOW = {
  0: 0, // 신청
  1: 1, // 진행중
  2: 2, // 지급완료
  3: 3, // 지급취소
  11: 4, // 지급거절
  31: 5, // 지급실패
  32: 6, // 지급실패(오류)
};

// Global withdraw type
export const GLOBAL_WITHDRAW_TYPE = {
  3: 'cash',
  6: 'nexonPoint',
};
